import DbConfig from '../../../config/DbConfig.js'
import {rtrim,getCurrentTime} from '../../functions/Common.js'

// 获取本地最近聊天列表
export function getFansList(custom_id,lastId,param,callback){
	lastId = parseInt(lastId)
	let db = DbConfig.connect()
	let sql = 'select * from yswl_custom_friends where id > '+ lastId
	if(custom_id != 0){
		sql += ' and custom_id = '+ custom_id
	}
	// 已聊天的
	if(param.optType === 'chat'){
		sql += ' and fans_type  != "W"'
	}
	// 未聊天的
	else if(param.optType === 'no-chat'){
		sql += ' and fans_type  = "W"'
	}
	// 点赞过的粉丝
	else if(param.optType === 'zan'){
		sql += ' and is_zan  = 1'
	}
	// 评论过的粉丝
	else if(param.optType === 'comment'){
		sql += ' and is_comment = 1'
	}
	// 微信昵称搜索
	if(param.keyword !== undefined && param.keyword !== ''){
		sql += ' and wx_name like "%' + param.keyword + '%"'
	}
	sql += ' order by id asc limit 20'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 获取本地聊天列表中各个类型的粉丝数量
export function getFansCount(custom_id,callback){
	let db = DbConfig.connect()
	let sql = 'select id,fans_type,is_zan,is_comment from yswl_custom_friends where'
	if(custom_id != 0){
		sql += ' custom_id = '+ custom_id + 'and'
	}
	sql = rtrim(rtrim(sql,'where'),'and')
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let total = results.rows.length
			let chatTotal = 0
			let noChatTotal = 0
			let zanChatTotal = 0
			let commentChatTotal = 0
			for(let i = 0;i < results.rows.length;i++){
				if(results.rows[i].fans_type === 'W'){
					noChatTotal++
				}
				if(results.rows[i].fans_type !== 'W'){
					chatTotal++
				}
				if(results.rows[i].is_zan === 1){
					zanChatTotal++
				}
				if(results.rows[i].is_comment === 1){
					commentChatTotal++
				}
			}
			callback({
				total,
				chatTotal,
				noChatTotal,
				zanChatTotal,
				commentChatTotal
			})
		})
	})
}

// 根据Id，获取粉丝信息
export function getFansById(id,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('select * from yswl_custom_friends where id = '+id,[],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 根据wxid，获取粉丝信息
export function getFansByWxid(wxid,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('select * from yswl_custom_friends where open_id = "' + wxid + '"',[],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 根据客服id，粉丝wxid，获取粉丝信息-异步回调
export function getFansByCustomIdAndWxid(customId,wxid,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('select * from yswl_custom_friends where custom_id = ? and open_id = ?',[customId,wxid],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 根据客服id，粉丝wxid，获取粉丝信息-同步回调
export function getFansByCustomIdAndWxidSync(customId,wxid){
	return new Promise(function(resolve, reject){
		let db = DbConfig.connect()
		db.transaction(tx=>{
			tx.executeSql('select * from yswl_custom_friends where custom_id = ? and open_id = ?',[customId,wxid],(tx,results)=>{ 
				let data = {}
				if(results.rows.length > 0){
					data = results.rows[0]
				}
				resolve(data)
			})
		})
	}).then((data)=>{
		return data
	})
}

// 根据客服id，粉丝wxid集合，获取粉丝列表信息
export function getFansListByCustomIdAndWxids(customId,wxids,callback){
	if(wxids instanceof Array){
		wxids = wxids.join("','")
		wxids = "'"+wxids+"'"
	}
	let db = DbConfig.connect()
	let sql = 'select * from yswl_custom_friends where custom_id = '+ customId +' and open_id in('+ wxids +')'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

// 根据id，获取粉丝信息和客服的信息
export function getFansWithCustomById(id,callback){
	let db = DbConfig.connect()
	let sql = 'SELECT cf.id AS fans_id,cf.open_id AS fans_wx_id,cf.wx_name AS fans_wx_name,cf.wx_photo AS fans_wx_photo,cf.custom_id,cf.con_remark,cf.sex,cf.country,cf.province,cf.city,c.open_id as custom_wx_id,c.wx_name as custom_wx_name,c.wx_photo as custom_wx_photo,c.identity,c.phone_id,c.is_online '
	sql += 'FROM yswl_custom_friends AS cf LEFT JOIN yswl_custom AS c ON cf.custom_id = c.id WHERE cf.id = '+id
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let data = {}
			if(results.rows.length > 0){
				data = results.rows[0]
			}
			callback(data)
		})
	})
}

// 根据客服id，粉丝标签获取粉丝列表
export function getFansByCustomIdAndTag(customId,param,callback){
	if(customId === undefined || customId === 0){
		callback([])
		return
	}
	let db = DbConfig.connect()
	let sql = 'select cf.* from yswl_custom_friends as cf left join yswl_custom_friends_tags as cft on cf.id = cft.friend_id where cf.custom_id= '+customId
	// 筛选条件处理
	if(param.tag !== undefined && param.tag !== "" ){
		sql += ' and cft.tag_value = "'+param.tag+'"'
	}
	if(param.name !== undefined && param.name !== "" ){
		sql += ' and (cf.wx_name like "%'+param.name+'%" or cf.con_remark like "%'+param.name+'%")'
	}
	if(param.startTime !== undefined && param.startTime !== "" && param.endTime !== undefined && param.endTime !== ""){
		sql += ' and cf.create_time between '+param.startTime+' and ' + param.endTime
	}
	sql += ' group by cf.id'
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			let list = []
			for(let i = 0;i < results.rows.length;i++){
				list.push(results.rows[i])
			}
			callback(list)
		})
	})
}

/**
 * 获取本地粉丝列表-带有上下分页的
 * @param {Object} param 搜索参数集合
 * @param {Object} callback 回调函数
 * @param {Object} allFlag 是否查询所有
 */
export function getFansListWithPage(param,callback,allFlag){
	let db = DbConfig.connect()
	let page = 1
	let prePage = 10
	if(param.page !== undefined){
		page = param.page
	}
	if(param.prePage !== undefined){
		prePage = param.prePage
	}
	// 查询列表的sql
	let sql = 'select cf.id,cf.open_id,cf.wx_name,cf.con_remark,cf.alias,c.open_id as custom_open_id,c.phone_id,GROUP_CONCAT(DISTINCT cft.tag_value) as tags from yswl_custom_friends as cf'
		     +' inner join yswl_custom as c on cf.custom_id = c.id'
			 +' left join yswl_custom_friends_tags as cft on cft.friend_id = cf.id where'
	// 查询总数的sql
	let countSql = 'select count(*) as total from yswl_custom_friends as cf'
		     +' inner join yswl_custom as c on cf.custom_id = c.id'
			 +' left join yswl_custom_friends_tags as cft on cft.friend_id = cf.id where'
	// 搜索条件拼接
	if(param.start_time !== undefined && param.start_time !== '' && param.end_time !== undefined && param.end_time !== '' ){
		sql += ' cf.create_time BETWEEN "'+ param.start_time +'" and "' + param.end_time + '" and'
		countSql += ' cf.create_time BETWEEN "'+ param.start_time +'" and "' + param.end_time + '" and'
	}
	if(param.wx_name !== undefined && param.wx_name !== ''){
		sql += ' (cf.wx_name like "%' + param.wx_name + '%" or cf.con_remark like "%' + param.wx_name + '%") and'
		countSql += ' (cf.wx_name like "%' + param.wx_name + '%" or cf.con_remark like "%' + param.wx_name + '%") and'
	}
	if(param.custom_id !== undefined && param.custom_id !== ''){
		sql += ' cf.custom_id = ' + param.custom_id + ' and'
		countSql += ' cf.custom_id = ' + param.custom_id + ' and'
	}
	if(param.fans_type !== undefined && param.fans_type !== ''){
		sql += ' cf.fans_type = "' + param.fans_type + '" and'
		countSql += ' cf.fans_type = "' + param.fans_type + '" and'
	}
	if(param.tag !== undefined && param.tag !== ''){
		sql += ' cft.tag_value = "' + param.tag + '" and'
		countSql += ' cft.tag_value = "' + param.tag + '" and'
	}
	// 去除sql最后面的and或者where
	sql = rtrim(rtrim(sql,'where'),'and')
	countSql = rtrim(rtrim(countSql,'where'),'and')
	
	// 涉及到标签，必须分组
	sql += ' group by cf.id'
	countSql = 'SELECT COUNT(*) as total from (' + countSql + ' group by cf.id) as temp'
	// 拼接其他sql
	if(allFlag === undefined || allFlag === false){
		sql += ' order by cf.id asc limit '+prePage+' OFFSET ' + (page - 1) * prePage
	}
	db.transaction(tx=>{
		// 先查询总数
		tx.executeSql(countSql,[],(tx,results)=>{
			let total = 0
			let data = []
			if(results.rows.length === 0){
				callback({
					total: total,
					data: data
				})
			}else{
				let total = results.rows[0].total
				// 再查询列表
				tx.executeSql(sql,[],(tx,results)=>{
					let list = []
					for(let i = 0;i < results.rows.length;i++){
						list.push(results.rows[i])
					}
					callback({
						total: total,
						data: list
					})
				})
			}
		})
		
	})
}

// 根据客服id，粉丝标签获取粉丝列表
export function saveFriend(data,callback){
	if(data === undefined || data.friend_id === undefined || data.custom_id === undefined){
		callback(false)
		return
	}
	let id = data.friend_id
	let custom_id = data.custom_id
	let open_id = data.friend_open_id
	let wx_name = data.friend_name !== undefined ? data.friend_name : ''
	let wx_photo = data.friend_avatar !== undefined ? data.friend_avatar: ''
	let friend_type = data.friend_type  !== undefined ? data.friend_type: 0
	let alias = data.alias  !== undefined ? data.alias: ''
	let con_remark = data.con_remark  !== undefined ? data.con_remark: ''
	let sex = data.sex !== undefined ? data.sex: 0
	let country = data.country !== undefined ? data.country: ''
	let province = data.province !== undefined ? data.province: ''
	let city = data.city !== undefined ? data.city: ''
	let sign = data.sign !== undefined ? data.sign: ''
	let fans_type = data.fans_type !== undefined ? data.fans_type: 'W'
	let is_comment = 0
	let is_zan = 0
	let mobile = data.mobile !== undefined ? data.mobile: ''
	let create_time = data.create_time !== undefined ? data.create_time : getCurrentTime()
	
	let db = DbConfig.connect()
	let sql = 'insert into yswl_custom_friends(id,custom_id,open_id,wx_name,wx_photo,friend_type,alias,con_remark,sex,sign,fans_type,is_comment,is_zan,country,province,city,create_time,mobile) values(?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?) '
	db.transaction(tx=>{
		tx.executeSql(sql,[id,custom_id,open_id,wx_name,wx_photo,friend_type,alias,con_remark,sex,sign,fans_type,is_comment,is_zan,country,province,city,create_time,mobile],(tx,results)=>{ 
			callback({
				id,
				custom_id,
				open_id,
				wx_name,
				wx_photo,
				friend_type,
				alias,
				con_remark,
				sex,
				sign,
				fans_type,
				is_comment,
				is_zan,
				mobile
			})
		},(tx,error)=>{
			callback(false)
		})
	})
}

// 修改粉丝数据
export function updateFriend(data,callback){
	if(data.id === undefined){
		callback(false)
		return
	}
	let db = DbConfig.connect()
	let sql = 'update yswl_custom_friends'
	if(data.con_remark !== undefined){
		sql += ' set con_remark = "'+ data.con_remark + '",'
	}
	if(data.sex !== undefined){
		sql += ' set sex = '+ data.sex + ','
	}
	if(data.is_comment !== undefined){
		sql += ' set is_comment = '+ data.is_comment + ','
	}
	if(data.is_zan !== undefined){
		sql += ' set is_zan = '+ data.is_zan + ','
	}
	sql = rtrim(sql,',')
	sql += ' where id = '+ data.id
	if(sql.indexOf('set') === -1){
		callback(false)
		return
	}
	db.transaction(tx=>{
		tx.executeSql(sql,[],(tx,results)=>{ 
			callback(true)
		},(tx,error)=>{
			console.log(error)
			callback(false)
		})
	})
}

// 根据id, 删除
export function deleteFriendById(id,callback){
	let db = DbConfig.connect()
	db.transaction(tx=>{
		tx.executeSql('delete from yswl_custom_friends where id = ?',[id],(tx,results)=>{ 
			callback(true)
		},(error,tx)=>{
			callback(false)
		})
	})
}